import { render, staticRenderFns } from "./FormSalaries.vue?vue&type=template&id=adbbeb50&"
import script from "./FormSalaries.vue?vue&type=script&lang=js&"
export * from "./FormSalaries.vue?vue&type=script&lang=js&"
import style0 from "./FormSalaries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports